.form-title {
  margin-top: 2.6rem;

  font-size: 1.5rem;
  line-height: 1.8rem;
  color: var(--color-grayscale-light-slate);
  font-weight: 500;
}

.has-server-response {
  margin-top: 0.8rem;
  margin-bottom: 0.8rem;
  max-width: 31rem;
}

.field-container {
  margin-top: 0.8rem;
}
